import { useState } from "react";

export type Platform = "darwin" | "win32" | "linux";

/** Detección síncrona por userAgent (disponible en el renderer de Electron). */
const detectPlatform = (): Platform => {
  const userAgent =
    typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
  if (userAgent.includes("Mac")) return "darwin";
  if (userAgent.includes("Linux")) return "linux";
  return "win32";
};

export const usePlatformDetection = () => {
  // Init LAZY síncrono (no default "win32" + efecto): con la title bar
  // renderizando en mac (item #7), un default win32 mostraría los botones Win +
  // padding equivocado en el PRIMER frame hasta que corriera el efecto (flash).
  const [platform] = useState<Platform>(detectPlatform);

  return platform;
};
